import { render } from "./HuruCriminalCheckManagement.vue?vue&type=template&id=31af0a20&scoped=true"
import script from "./HuruCriminalCheckManagement.vue?vue&type=script&lang=js"
export * from "./HuruCriminalCheckManagement.vue?vue&type=script&lang=js"

import "./HuruCriminalCheckManagement.vue?vue&type=style&index=0&id=31af0a20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31af0a20"]])

export default __exports__